import { render, staticRenderFns } from "./AppPubPost.vue?vue&type=template&id=02a829c3&"
import script from "./AppPubPost.vue?vue&type=script&lang=js&"
export * from "./AppPubPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports